/* Lightbox for post/page gallery images (loaded only on post & page templates) */
(function () {
    if (typeof lightbox !== 'function') return;

    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();
